module.exports = __webpack_public_path__ + "img/proveedores.af2b9ec6.png";